import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import { ChatListState, ChatListStateModel } from './chat-list.state';

@Injectable()
export class ChatListSelectors {
   @Selector([ChatListState])
   public static isChatListOpen(state: ChatListStateModel) {
      return state.isOpen;
   }
}
